import React from 'react';
import g from 'glamorous';

import BuyBook from '../components/buybook';

import { linkColor } from '../utils/typography';

import {
  maxLayoutWidth,
  normalMargin,
  largeMargin,
  largeBreakpoint
} from '../utils/layout-units';

const maxSmallTitles = '399px';
const maxSmallTopMargin = '511px';

const Title = g.h1({
  flex: '0 0 auto',
  margin: `48px 0 4px ${normalMargin}`,
  [`@media (max-width: ${maxSmallTitles})`]: {
    flex: '0 0 100%',
    fontSize: '30px',
  },
  [`@media (max-width: ${maxSmallTopMargin})`]: {
    marginTop: '40px',
  },
  [`@media (min-width: ${largeBreakpoint})`]: {
    marginLeft: largeMargin,
  },
});

const Subtitle = g.h2({
  flex: '0 0 auto',
  marginLeft: normalMargin,
  marginRight: normalMargin,
  [`@media (max-width: ${maxSmallTitles})`]: {
    fontSize: '22px',
  },
})

export default ({children}) => (
  <g.Div
      maxWidth={maxLayoutWidth}
      minHeight="100vh"
      overflow="hidden"
      margin="0 auto"
      paddingBottom="40px"
      boxShadow={`inset 0 1px 0 0 ${linkColor}`}>
    <g.Div
        display="flex"
        justifyContent="flex-start"
        flexWrap="wrap"
        alignItems="baseline">
      <Title>Sarah Coleman</Title><Subtitle>Writer</Subtitle>
    </g.Div>
    <div>
      { children() }
    </div>
    <BuyBook/>
  </g.Div>
);


// WEBPACK FOOTER //
// ./src/layouts/index.js